export default __webpack_public_path__ + "static/more_info_popup-eb177c82aada54eac862454a87d125e7.png";